import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { TechScoreService } from 'src/app/services/tech-score.service';
import { TechnicianService } from 'src/app/services/technician.service';
import { TranslaterService } from 'src/app/services/translater.service';
import { BaseApi } from 'src/backend/api/base-api';

@Component({
    selector: 'app-technician-responsible-dialog',
    template: `
    
    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center">
        <h2>Add Technician Responsible</h2>
        <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <div class="w-100">
        <form [formGroup]="form" class="dialog-form">
            <div class="w-100 techForm">
                <mat-form-field appearance="fill" class="full-width">
                    <mat-label>{{langObj ? langObj?.Technician : ('Technician' | translate)}}<span> *</span></mat-label>
                    <mat-select formControlName="technician" (openedChange)="onPanelClose($event, machineSearchInput)">
                        <input #machineSearchInput (keyup)="searchValues($event)" class="form-control w-100" placeholder="Search Technicians">
                        <mat-option *ngFor="let tech of filteredTechnicianList" [value]="tech.id">
                            {{ tech.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.get('technician')?.hasError('required') && form.get('technician')?.touched">
                        Technician is required
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill" class="full-width">
                    <mat-label>{{langObj ? langObj?.Remarks : ('Remarks' | translate)}}<span> *</span></mat-label>
                    <textarea matInput formControlName="note" placeholder="Enter a remarks" rows="5"></textarea>
                    <mat-error *ngIf="form.get('note')?.hasError('required') && form.get('note')?.touched">
                        Remarks is required
                    </mat-error>
                </mat-form-field>
<!-- 
                <div class="dialog-actions">
                    <button mat-flat-button color="warn" (click)="close()">{{langObj ? langObj?.Cancel : ("Cancel" | translate)}}</button>
                    <button mat-flat-button color="primary" (click)="save()" [disabled]="form.invalid">
                        {{ langObj ? langObj?.Submit : ("Submit" | translate) }}
                    </button>
                </div> -->
                <div class="center w-100 my-2">
                    <button class="submit" (click)="save()" type="submit float-right">
                        {{ langObj ? langObj?.Submit : ("Submit" | translate) }}
                    </button>
                    <button class="cancel" (click)="close()" type="button"> {{langObj ? langObj?.Cancel : ("Cancel" | translate)}}
                    </button>
                </div>
            </div>
        </form>
    </div>
  `,
    styles: [`
  .full-width {
    width: 100%;
  }

  .dialog-form {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .w-100 {
  width: 100%;
    }
  .center {
  text-align: center;
  display: flow-root;
  .submit {
    background-color: #0f0fd1;
    color: white;
    padding: 8px 22px 8px 22px;
    font-weight: 700;
    font-size: 15px;
    border: none;
    cursor: pointer;
    border-radius: 5px;
    float: right;
  }
  .cancel {
    background-color: red;
    color: white;
    padding: 8px 22px 8px 22px;
    font-weight: 700;
    font-size: 15px;
    border: none;
    cursor: pointer;
    border-radius: 5px;
    float: right;
    margin-right: 1%;
  }
}
.techForm {
  ::ng-deep .mat-form-field-underline {
    width: unset !important;
  }

  ::ng-deep .mat-form-field-flex {
    border: 1px solid #cacaca;
    box-sizing: border-box;
    border-radius: 10px;
    padding: 3px 7px 0;
  }
  ::ng-deep .mat-form-field-appearance-legacy .mat-form-field-underline {
    background-color: unset !important;
  }
}
`]

})
export class TechnicianResponsibleDialogComponent implements OnInit {
    form!: FormGroup;
    technicians: any[] | any = [];
    plantSession: any;
    groupSession: any;
    plantCode: any;
    pageId: string;
    moduleId: any;
    langObj: any;
    filteredTechnicianList: any[] | any = [];
    constructor(
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<TechnicianResponsibleDialogComponent>,
        private technicianService: TechnicianService,
        public translate: TranslateService,
        public translater: TranslaterService,
        private techScoreService: TechScoreService,
        private baseApi: BaseApi,
        @Inject(MAT_DIALOG_DATA) public data: { woId: number }
    ) { }
    searchValues(event: any) {
        const filter = event.target.value.toLowerCase();
        if (filter) {
            this.filteredTechnicianList = this.technicians.filter(tech => tech.name.toLowerCase().includes(filter));
        }
    }
    ngOnInit(): void {
        this.getSessionData();
        this.getTechnicians();
        this.form = this.fb.group({
            technician: [null, Validators.required],
            note: ['', Validators.required]
        });
    }
    public getLangWords() {
        this.pageId = this.baseApi.getCurrentMenuID();
        const userMenus = this.baseApi.getUserPermissionsSession();
        this.moduleId = userMenus.find(x => x.menuId === this.pageId)?.parentId;
        const key = {
            ModuleId: this.moduleId,
            PageId: this.pageId,
            LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : 1
        };
        this.translater.getLangWords(key).subscribe((res: any) => {
            let obj: any = {};
            res.tagList.map((elem: any) => {
                obj[elem.tagName] = elem.translatedValue;
            });
            this.langObj = obj;
        });
    }
    getSessionData(): void {
        this.groupSession = this.baseApi.getGroupFromStorage();
        this.plantSession = this.baseApi.getPlantFromStorage();
        this.plantCode = this.plantSession.plantCode
    }
    onPanelClose(isOpen: boolean, inputElement: HTMLInputElement) {
        if (!isOpen) {
            // Reset the search input value
            inputElement.value = '';
            this.filteredTechnicianList = [...this.technicians];

        }
    }
    getTechnicians(): void {
        if (!this.plantCode) {
            console.warn('Plant code is not available');
            this.technicians = [];
            return;
        }

        const key = {
            Plant: this.plantSession?.plantCode
        }

        this.techScoreService
            .getAllTechScoreList(key)
            .subscribe({
                next: (res: any[]) => {
                    // Remove duplicates based on TechId or EmployeeCode
                    const uniqueTechnicians = Array.from(
                        new Map(
                            res.map((item) => [
                                item.TechId || item.EmployeeCode,
                                {
                                    id: item.TechId || item.EmployeeCode,
                                    name: item.full_name,
                                },
                            ])
                        ).values()
                    );

                    this.technicians = uniqueTechnicians;
                    this.filteredTechnicianList = this.technicians; // Initialize filtered list with all technicians
                    console.log('Technicians loaded:', this.technicians);
                },
                error: (err) => {
                    console.error('Error fetching technicians:', err);
                    this.technicians = [];
                },
            });
    }

    save(): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }

        const payload = {
            WOId: this.data.woId,
            TechnicianId: this.form.value.technician,
            Remarks: this.form.value.note
        };

        this.technicianService.assignTechnician(payload).subscribe({
            next: (response) => {
                console.log('Technician assigned successfully:', response);
                this.dialogRef.close(true);
            },
            error: (error) => {
                console.error('Error assigning technician:', error);
                // Optionally show an error notification
            }
        });
    }

    close(): void {
        this.dialogRef.close();
    }
}
